import { useCallback, useEffect, useRef } from 'react';
import { cancelSpeech } from '../utils/tts';

/** Scheduled steps of a stage director. Cleared together on barge-in, moment change and unmount. */
export function useTimers() {
  const timers = useRef<number[]>([]);

  const later = useCallback((fn: () => void, ms: number) => {
    timers.current.push(window.setTimeout(fn, ms));
  }, []);

  const clearTimers = useCallback(() => {
    timers.current.forEach((id) => window.clearTimeout(id));
    timers.current = [];
  }, []);

  useEffect(
    () => () => {
      clearTimers();
      cancelSpeech();
    },
    [clearTimers],
  );

  return { later, clearTimers };
}
